import script from "./paidSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./paidSetting.vue?vue&type=script&lang=ts&setup=true"

import "./paidSetting.vue?vue&type=style&index=0&id=8f869478&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f869478"]])

export default __exports__